import { Modal } from '@razorpay/blade/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { useFormWithProvider } from 'forms';
import { Wizard, WizardStep } from 'forms/Wizard';
import React from 'react';
import BasicDetailsStep from './BasicDetailsStep';
import { INITIAL_FORM_DATA } from './constants';
import DefineStructureStep from './DefineStructureStep';
import { SalaryStructureFormData } from './types';

type SalaryStructureCreationFlowProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SalaryStructureCreationFlow = ({ isOpen, onClose }: SalaryStructureCreationFlowProps) => {
  const { setFormData } = useFormWithProvider<SalaryStructureFormData>();

  const handleClose = () => {
    setFormData(INITIAL_FORM_DATA);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onDismiss={handleClose} size="full">
      <WizardInfoProvider initialStep={0} totalSteps={2} onWizardClose={onClose}>
        <Wizard>
          <WizardStep step={0} component={BasicDetailsStep} />
          <WizardStep step={1} component={DefineStructureStep} />
        </Wizard>
      </WizardInfoProvider>
    </Modal>
  );
};

export default SalaryStructureCreationFlow;
